<app-floating-visor style="position: absolute; user-select: none; z-index: 120; height: 0px;" [width]="previewSize"
  [height]="previewSize" [left]="previewLeft" [top]="70" [showWindowingTool]="showWindowingTool" (closeVisor)="showMenu()">
</app-floating-visor>

<app-download-modal-mobile></app-download-modal-mobile>

<div class="w-100 h-100 d-flex justify-content-center align-items-center"
  style="position:absolute;top:0;left:0; z-index: 999; background-color: rgba(139, 139, 139, 0.486);"
  *ngIf='showSpinner'>
  <div class="spinner-border text-light" role="status">
  </div>
  <span class="ms-3">Cargando...</span>
</div>

<div class="h-100 d-flex flex-column" *ngIf="bookService.currentBook!=null">

  <app-vertical-header
    (menuClick)="toggleMenu()"
    (onClickViewer)="openAdvancedVisor()">
  </app-vertical-header>

  <app-side-menu
    [visibleButtons]="['download','share','info','history','report','viewer','book']"
    [opened]="menuOpened"
    [actualBookStudies]="bookStudies"
    (close)="closeMenu()"
    (onClickShare)="openShareModal()"
    (onClickInfo)="openInfoModal()"
    (onClickViewer)="openAdvancedVisor()"
    (onClickChangeTab)="setTab($event)">
  </app-side-menu>

  <!--<div class="page-counter" *ngIf="activeTab === 'book'">
    {{ currentSlide }} / {{ bookService.allPages.length }}
  </div>-->

  <div class="flex-grow-1 overflow-hidden" style="margin-top: 10px;" id="book-container" *ngIf="activeTab === 'book'">
    <div class="col-12 h-100" style="position: relative;">

      <!--<button class="swiper-nav-btn swiper-nav-prev"
        (click)="slidePrev()" [disabled]="currentSlide === 1">
        <span class="material-icons">chevron_left</span>
      </button>-->

      <swiper-container 
        #bookSwiper
        id="bookSwiper"
        init="false"
        touch-start-prevent-default="false"
        (swiperslidechange)="onSlideChange($event)">
        <swiper-slide class="page report-container"
          *ngFor='let page of bookService.allPages'>
          <div style="height: 100%;" *ngIf="page != null && page.type != BookPageType.REPORT"
            [ngStyle]="{backgroundColor: (page.type == BookPageType.IMAGES) ? 'black' : 'white'}">
            <div *ngFor='let img of page.bookImages' style="display: inline-block; position: relative;"
              (click)="(page.type == BookPageType.IMAGES && img.dicomFile) ? openPreview(img) : null"
              [ngClass]="{clickable:img.dicomFile!=null}" class='book-image-container'
              [ngStyle]="{height: img.height+'%', width: img.width+'%'}"
              [style.borderColor]="(page.type == BookPageType.IMAGES && img.isKo) ? '#f2c63d38' : ''">
              <img draggable="false" style="width: 100%; height: 100%; object-fit: contain;"
                [src]="imagesService.getImage(img.pngFile)" *ngIf="img.mp4File==null">
              <video draggable="false" class="multiframe-video" muted
                *ngIf="img.mp4File!=null && imagesService.getSingleImage(img.mp4File)!=null"
                style="width: 100%;height: 100%;">
                <source [src]="imagesService.getSingleImage(img.mp4File)" type="video/mp4">
                Your browser does not support the video.
              </video>
              <span *ngIf="(img.type == BookImageType.SERIES) && img.dicomFile"
                style="position: absolute;top: 4px;left: 4px;">serie</span>
              <span *ngIf="(img.type == BookImageType.CINE) && img.dicomFile"
                style="position: absolute;top: 4px;left: 4px;">cine</span>
              <span *ngIf="(img.type == BookImageType.GRID) && img.dicomFile"
                style="position: absolute;top: 4px;left: 4px;">grid</span>
              <div *ngIf="(page.type == BookPageType.IMAGES) && img.isKo"
                style="position: absolute;top: 2px;left: 4px;color: #f2c53de0">
                <span class='d-block' style="font-size: small;">Imagen</span>
                <span class='d-block' style="font-size: small;">Clave</span>
              </div>
            </div>
          </div>
          
        </swiper-slide>

        

      </swiper-container>

      <!--<button class="swiper-nav-btn swiper-nav-next"
        (click)="slideNext()" [disabled]="currentSlide === bookService.allPages.length">
        <span class="material-icons">chevron_right</span>
      </button>-->

      <div class="image-slider-bar">

        <button class="nav-arrow" (click)="slidePrev()" [disabled]="currentSlide === 1">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>

        <div class="slider-track-container">
          <div class="image-counter-pill">
            {{ currentSlide }} / {{ bookService.allPages.length }}
          </div>
          
          <input
            type="range"
            class="modern-slider"
            [min]="0"
            [max]="bookService.allPages.length - 1"
            [value]="currentSlide - 1"
            (input)="onSliderChange($event)">

        </div>

        <button class="nav-arrow" (click)="slideNext()" [disabled]="currentSlide === bookService.allPages.length">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>

    </div>
  </div>

  <!-- ===== HISTORY TAB ===== -->
   
  <app-mobile-history
    *ngIf="activeTab === 'history'"
    class="flex-grow-1 overflow-auto d-flex flex-column"
    [actualBookStudies]="bookStudies"
    [token]="token"
    (onClickChangeTab) = "setTab($event)"
    (openVisor)="openAdvancedVisor()"
    (openVisorFromHistoricStudy)="openAdvancedVisorFromHistoric($event)"
    (openBookFromHistoricStudy)="onClickOpenBook($event)">
  </app-mobile-history>

  <!-- ===== REPORTS TAB ===== -->
  <app-mobile-report-view
    *ngIf="activeTab === 'report'"
    class="flex-grow-1 overflow-auto d-flex flex-column"
    [bookReports]="bookReports"
    (downloadReport)="downloadReport()">
  </app-mobile-report-view>  


  <!-- ===== BOTTOM TAB BAR ===== -->
  <app-bottom-nav
    [hasReports]="bookReports != null && bookReports.length > 0"
    [activeTab]="activeTab"
    (tabChange)="setTab($event)">
  </app-bottom-nav>
  

  <!-- ===== REPORTS TAB ===== -->
  <!--
  <app-report-view
    [reportURL]="reportURL"
    [loading]="reportLoading"
    [reportCount]="reports.length"
    [reportIndex]="reportIndex"
    (onOpenExternal)="openReportInNewTab()"
    (prevReport)="onPrevReportClick()"
    (nextReport)="onNextReportClick()"
    style="height: 100% !important;">
  </app-report-view>  
  -->
</div>

<app-animations></app-animations>
<app-share-study></app-share-study>
<app-info-study></app-info-study>

